import React from 'react';
import { twMerge } from 'tailwind-merge';
import { CategoryTypeString } from '@diritto/common/content/constants';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { tm } from 'utils/tm';
import { DotDivider } from 'ui-components/common/DotDivider';
import { Link } from 'ui-components/common/Link';
import { ProfileName } from 'app-components/contents/ProfileName';
import { SectionContentKeywords } from 'app-components/home/sections/components/SectionContentKeywords';
import { ContentInlineBadges } from 'ui-components/contents/ContentInlineBadge';

const variant = {
  container: 'flex flex-row gap-1 line-height-initial text-xxxs font-medium text-gray-600',
  text: 'overflow-hidden text-ellipsis break-all',
};

interface SectionEventContentItemProps {
  content: ContentPublicRelayDto;
  profile: ProfileLitePublicRelayDto;
  onClick: (contentId: number) => void;
}

export const SectionEventContentItem = ({ content, profile, onClick }: SectionEventContentItemProps) => (
  <div key={content.id} className="w-full" onClick={() => onClick(content.id)}>
    <div className="flex flex-col justify-start items-start w-full h-[142px] overflow-hidden p-4 gap-1">
      <Link
        className="inline-flex flex-row justify-start items-start w-full overflow-hidden gap-1 h-6"
        href={`/contents/${content.id}`}>
        <ContentInlineBadges content={content} />
        <p className={twMerge(variant.text, 'text-black font-medium text-xs line-clamp-1 break-words')}>
          {content.title}
        </p>
      </Link>

      <div className={variant.container}>
        <ProfileName profile={profile} />
        <>
          <DotDivider />
          <p>{CategoryTypeString[content.categoryType]}</p>
        </>
        <DotDivider />
        <div>{`${content.counts.episodeCount}화`}</div>
      </div>

      <SectionContentKeywords
        keywords={content.keywords}
        className={twMerge(variant.container, 'text-gray-600 text-xxxs')}
      />

      <Link href={`/contents/${content.id}`} className={tm(variant.container, 'w-full h-[35px]')}>
        <div className={twMerge(variant.text, 'font-regular text-gray-700 line-clamp-2')}>{content.description}</div>
      </Link>
    </div>
  </div>
);
